import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Modal,
  Pagination,
  PaginationItem,
  Select,
  Typography,
} from "@mui/material";
import Header from "../Header";
import TableReport from "../TableReport";
import ModalError from "../Generics/ModalError";
import { useSelector } from "react-redux";
import { service } from "../../model";

const DashboardReader = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const emailSuperReader = process.env.REACT_APP_SUPER_READER_EMAIL;

  const reduxObject = useSelector((state) => state.user?.redux_object);
  const token = reduxObject.accessToken;

  const intestazioniReader = [
    { key: "id", label: "ID" },
    { key: "original_name", label: "Report" },
    { key: "datario", label: "Data report" },
  ];

  const intestazioniReaderFR = [
    { key: "id", label: "ID" },
    { key: "original_name", label: "Report" },
    { key: "datario", label: "Data report" },
    { key: "subject_reader_id", label: "Team" },
  ];

  const [filterAnno, setFilterAnno] = useState("");
  const [filterMese, setFilterMese] = useState("");

  const currentYear = new Date().getFullYear();
  const anni = Array.from({ length: currentYear - 2025 }, (_, i) => {
    const year = (2026 + i).toString();
    return { label: year, value: year };
  });

  const mesi = [
    { label: "Gennaio", value: "1" },
    { label: "Febbraio", value: "2" },
    { label: "Marzo", value: "3" },
    { label: "Aprile", value: "4" },
    { label: "Maggio", value: "5" },
    { label: "Giugno", value: "6" },
    { label: "Luglio", value: "7" },
    { label: "Agosto", value: "8" },
    { label: "Settembre", value: "9" },
    { label: "Ottobre", value: "10" },
    { label: "Novembre", value: "11" },
    { label: "Dicembre", value: "12" },
  ];

  const [isLoading, setIsLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [openModalError, setOpenModalError] = useState(false);
  const [modalErrorConfig, setModalErrorConfig] = useState({});
  const userEmail = reduxObject?.user?.email;
  const [readers, setReaders] = useState([]);
  const [filterSubjectReader, setFilterSubjectReader] = useState("");

  const [openFilter, setOpenFilter] = useState(false);

  const hasActiveFilters =
    filterAnno !== "" ||
    filterMese !== "" ||
    (userEmail === emailSuperReader && filterSubjectReader !== "");
  const showFilterButton =
    documents.length > 0 || hasActiveFilters || isLoading;

  const PER_PAGE = 25; // 25

  const showError = (title, descriptionOne, descriptionTwo = "") => {
    setModalErrorConfig({ title, descriptionOne, descriptionTwo });
    setOpenModalError(true);
  };

  const loadAppData = async (filters = {}, page = 1) => {
    if (!reduxObject?.accessToken) return;
    setIsLoading(true);
    try {
      const docs = await service.getDocuments(token, {
        ...filters,
        page,
        per_page: PER_PAGE,
      });
      setDocuments(
        docs.data.map((doc) => ({
          ...doc,
          reader: doc.reader?.name ?? doc.reader ?? "",
        })),
      );
      setLastPage(docs.last_page);
      setCurrentPage(docs.current_page);

      if (userEmail === emailSuperReader) {
        try {
          const users = await service.getAllUsers(token);
          setReaders(users);
        } catch (err) {
          console.error("Error", err);
        }
      }
    } catch (err) {
      console.error("Error", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!reduxObject?.accessToken) return;
    loadAppData({
      year: filterAnno || "",
      month: filterMese || "",

      ...(userEmail === emailSuperReader && filterSubjectReader
        ? { subject_reader_id: filterSubjectReader }
        : {}),
    });
  }, [reduxObject, filterAnno, filterMese, filterSubjectReader]);

  const handleDownload = async (doc) => {
    setIsDownloading(true);
    try {
      const blob = await service.downlaodDocument(token, doc.id);
      const url = window.URL.createObjectURL(blob);
      const link = window.document.createElement("a");
      link.href = url;
      link.download = doc.original_name || "download";
      window.document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error", error);
      showError(
        "Errore download",
        "Impossibile scaricare il file.",
        "Riprova più tardi.",
      );
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      {isDownloading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress sx={{ color: "#fff" }} />
        </div>
      )}

      <div
        style={{ display: "flex", flexDirection: "column", height: "100vh" }}
      >
        <div style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}>
          <Header />
        </div>
        <Grid
          container
          justifyContent="center"
          sx={{ mt: "140px", px: 2, pb: "80px" }}
        >
          <Grid item xs={12} md={10}>
            <Typography sx={{ fontSize: 22, fontWeight: 600, mb: 3 }}>
              Lista report
            </Typography>

            {showFilterButton && (
              <Grid item xs={12} sx={{ mb: 2 }}>
                <Button
                  variant="outlined"
                  sx={{
                    height: "30px",
                    width: "80px",
                    borderRadius: "10px",
                    borderColor: "#1b2838",
                    textTransform: "initial",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { xs: "space-around", sm: "space-between" },
                    px: "15px",
                    "&:hover": {
                      borderColor: "#1b2838",
                      backgroundColor: "#f9f9f9",
                    },
                  }}
                  onClick={() => setOpenFilter((prev) => !prev)}
                >
                  {openFilter ? (
                    <Box
                      className="icon-filter-close-report-button"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                  ) : (
                    <Box
                      className="icon-filter-report-button"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                  )}

                  <Typography
                    className="color-blue-dark"
                    sx={{
                      fontSize: { xs: "14px", sm: "14px" },
                      fontWeight: 500,
                    }}
                  >
                    Filtri
                  </Typography>
                </Button>
              </Grid>
            )}

            {/* FILTRI */}
            {openFilter && showFilterButton && (
              <Grid container spacing={2} sx={{ mb: 3 }}>
                {/* ANNO */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2.5}
                  sx={{ mb: { xs: 2, md: 0 } }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "14px !important",
                        md: "14px !important",
                      },
                      mb: 0.5,
                    }}
                    className="color-blue-dark title-input"
                  >
                    Anno
                  </Typography>
                  <Select
                    value={filterAnno}
                    onChange={(e) => setFilterAnno(e.target.value)}
                    displayEmpty
                    fullWidth
                    sx={{ height: { xs: "40px", md: "40px" } }}
                  >
                    <MenuItem value="">
                      <span style={{ color: "#abb0b6" }}>Seleziona</span>
                    </MenuItem>
                    {anni.map((a) => (
                      <MenuItem key={a.value} value={a.value}>
                        <Typography className="color-blue-dark">
                          {a.label}
                        </Typography>
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* MESE */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2.5}
                  sx={{ mb: { xs: 2, md: 0 } }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "14px !important",
                        md: "14px !important",
                      },
                      mb: 0.5,
                    }}
                    className="color-blue-dark title-input"
                  >
                    Mese
                  </Typography>
                  <Select
                    value={filterMese}
                    onChange={(e) => setFilterMese(e.target.value)}
                    displayEmpty
                    fullWidth
                    sx={{ height: { xs: "40px", md: "40px" } }}
                  >
                    <MenuItem value="">
                      <span style={{ color: "#abb0b6" }}>Seleziona</span>
                    </MenuItem>
                    {mesi.map((m) => (
                      <MenuItem key={m.value} value={m.value}>
                        <Typography className="color-blue-dark">
                          {m.label}
                        </Typography>
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* LETTORE SOGGETTO - solo superReader */}
                {userEmail === emailSuperReader && (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={2.5}
                    sx={{ mb: { xs: 2, md: 0 } }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          xs: "14px !important",
                          md: "14px !important",
                        },
                        mb: 0.5,
                      }}
                      className="color-blue-dark title-input"
                    >
                      Team
                    </Typography>
                    <Select
                      value={filterSubjectReader}
                      onChange={(e) => setFilterSubjectReader(e.target.value)}
                      displayEmpty
                      fullWidth
                      sx={{ height: { xs: "40px", md: "40px" } }}
                    >
                      <MenuItem value="">
                        <span style={{ color: "#abb0b6" }}>Seleziona</span>
                      </MenuItem>
                      {readers.map((r) => (
                        <MenuItem key={r.id} value={r.id}>
                          <Typography className="color-blue-dark">
                            {r.name}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                )}

                {/* RESET */}
                <Grid
                  item
                  xs={6}
                  sm={1.5}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: { xs: "0px", sm: "28px" },
                  }}
                >
                  <Button
                    variant="outlined"
                    fullWidth
                    sx={{
                      height: "30px",
                      width: "60px",
                      borderRadius: "10px",
                      borderColor: "#c4c4c4",
                      textTransform: "initial",
                      "&:hover": {
                        borderColor: "#1b2838",
                        backgroundColor: "#f9f9f9",
                      },
                    }}
                    onClick={() => {
                      setFilterAnno("");
                      setFilterMese("");
                      setFilterSubjectReader("");
                    }}
                  >
                    {/* <Typography
                      className="color-blue-dark"
                      sx={{
                        fontSize: { xs: "14px", sm: "14px" },
                        fontWeight: 500,
                      }}
                    >
                      Reset
                    </Typography> */}
                    <Box
                      className="icon-filter-reset-report-button"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                  </Button>
                </Grid>
              </Grid>
            )}

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <TableReport
                documents={documents}
                onDownload={handleDownload}
                intestazioni={
                  userEmail === emailSuperReader
                    ? intestazioniReaderFR
                    : intestazioniReader
                }
                isLoading={isLoading}
              />

              {lastPage > 1 && !isLoading && (
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center", mb: 3 }}
                >
                  <Pagination
                    count={lastPage}
                    page={currentPage}
                    onChange={(_, page) =>
                      loadAppData(
                        {
                          year: filterAnno || "",
                          month: filterMese || "",
                          ...(userEmail === emailSuperReader &&
                          filterSubjectReader
                            ? { subject_reader_id: filterSubjectReader }
                            : {}),
                        },
                        page,
                      )
                    }
                    shape="rounded"
                    renderItem={(item) => (
                      <PaginationItem
                        components={{
                          previous: () => (
                            <Box className="icon-arrow-pagination" />
                          ),
                          next: () => (
                            <Box className="icon-arrow-pagination right" />
                          ),
                        }}
                        {...item}
                      />
                    )}
                    sx={{
                      "& .MuiPaginationItem-root": {
                        color: "#1b2838",
                        borderColor: "#1b2838",
                        borderRadius: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                      "& .MuiPaginationItem-icon": {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: 0,
                      },
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: "#1b2838",
                        color: "#fff",
                        "&:hover": { opacity: 0.8 },
                      },
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </div>

      {/* MODAL ERROR */}
      <Modal open={openModalError} onClose={() => setOpenModalError(false)}>
        <Box>
          <ModalError
            title={modalErrorConfig.title}
            descriptionOne={modalErrorConfig.descriptionOne}
            descriptionTwo={modalErrorConfig.descriptionTwo}
            copyButton="Ok"
            onClose={() => setOpenModalError(false)}
            confirm={() => setOpenModalError(false)}
          />
        </Box>
      </Modal>
    </>
  );
};

export default DashboardReader;
